/* eslint-disable max-lines-per-function */
import { $Q, $Qll } from "../utils/query-selector";

/**
 * Validate in the URL if there is filter applied of price.
 * If It is false remove default value in filter price
 * It if true continuos
 * For mobile devices
 */
const initValues = () => {
  const MIN_INPUT_NAME = 'filter.v.price.gte'
  const MAX_INPUT_NAME = 'filter.v.price.lte'
  const pricein = $Qll(".price-in input");
  const url = new URLSearchParams(window.location.search)

  if (!url.get(MIN_INPUT_NAME) || !url.get(MAX_INPUT_NAME)) {
    pricein.forEach((input) => {
      input.removeAttribute('value')
    })
  }

}

/**
 *
 * we control the price range filter in order to avoid that the minimum
 * value is greater than the highest value and that the highest
 * value is not less than the lowest value
 *
 */
export function rangeFilters() {
  const rangeIn = $Qll(".range-in input");
  const priceIn = $Qll(".price-in input");
  const lstProgress = $Qll('.slider-filter .pro');
  const priceGap = 0;

  initValues();

  rangeIn.forEach((input) => {
    if (rangeIn[0].value) {
      lstProgress.forEach((progress) => {
        if (Number(rangeIn[0].value) >= Number(rangeIn[1].value)) {
          progress.style.left = `0%`;
          progress.style.right = `100%`;
          rangeIn[0].value = priceGap;
          rangeIn[1].value = priceGap;
          rangeIn[2].value = priceGap;
          rangeIn[3].value = priceGap;
        } else {
          progress.style.left = `${(rangeIn[0].value / rangeIn[0].max) * 100}%`;
          progress.style.right = `${100 - (rangeIn[1].value / rangeIn[1].max) * 100}%`;
        }
      });
    }

    input.addEventListener("input", (e) => {
      const currentProgress = $Q('.slider-filter .pro', input.closest('.filter'));
      const currentPriceIn = $Qll(".price-in input", input.closest('.filter'));
      const currentRangeIn = $Qll(".range-in input", input.closest('.filter'));
      const minVal = Number(currentRangeIn[0].value);
      const maxVal = Number(currentRangeIn[1].value);

      if (maxVal - minVal < priceGap) {
        if (e.target.className === "range-min") {
          rangeIn[0].value = maxVal - priceGap;
        } else {
          rangeIn[1].value = minVal + priceGap;
        }
      } else if (minVal === maxVal) {
        // Reset values if these are equals
          currentRangeIn[0].value = priceGap;
          currentRangeIn[1].value = rangeIn[1].max;
          currentPriceIn[0].value = cents(priceGap, true);
          currentPriceIn[1].value = rangeIn[1].max;
          currentProgress.style.left = `0%`;
          currentProgress.style.right = `0%`;
      } else {
        currentPriceIn[0].value = minVal;
        $Q(".range1 div").textContent = minVal;
        currentPriceIn[1].value = maxVal;
        $Q(".range2 div").textContent = maxVal;
        currentProgress.style.left = `${(minVal / rangeIn[0].max) * 100 }%`;
        currentProgress.style.right = `${100 - (maxVal / rangeIn[1].max) * 100 }%`;
      }
    });
  });
}

/**
 * The `cents` function takes a string representing cents and converts it to a number in dollars, with
 * an optional parameter to specify the number of decimal places.
 * @param str - The `str` parameter is a string representing a number in cents. For example, if `str`
 * is "500", it represents 500 cents, which is equal to .00.
 * @param fixed - The "fixed" parameter is a boolean value that determines whether the output should be
 * rounded to 2 decimal places or not. If "fixed" is true, the output will be rounded to 2 decimal
 * places using the toFixed() method. If "fixed" is false or not provided, the
 * @returns the number divided by 100. If the `fixed` parameter is true, it returns the number with 2
 * decimal places using the `toFixed` method. Otherwise, it returns the number as is.
 */
function cents(str, fixed) {
  const number = Number(str) / 100
  if (fixed) return number.toFixed(2);
  return number
}

/* The `(function formatValues() { ... })();` is an immediately invoked function expression (IIFE) that
is used to format the values of the input fields with the class "price-in". */
(function formatValues() {
  $Qll('.price-in input').forEach(
    (item) => {
      if (Number(item.value) > Number(item.min) && Number(item.value) < Number(item.max)) {
        item.value = item.value
      }
    },
  )
}());
